import {CountUp} from "countup.js";

window.addEventListener('load', () => {
    const countUpElements = document.querySelectorAll<HTMLElement>('[data-countup]');

    countUpElements.forEach((element) => {
        const value = parseFloat(element.getAttribute('data-countup') || '0.0');

        const countup = new CountUp(element, value, {
            decimalPlaces: 1,
            enableScrollSpy: true,
        });

        if (!countup.error) {
            countup.start();
        }
    });
});
